import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ChinookLogo from './../../Assets/Images/chinookLogo.webp';
import HomeIcon from '@mui/icons-material/Home';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import PaidIcon from '@mui/icons-material/Paid';
import CancelIcon from '@mui/icons-material/Cancel';
import { Link, useLocation } from 'react-router-dom';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import useMediaQuery from '@mui/material/useMediaQuery';
import { makeStyles } from '@material-ui/core/styles';

const drawerWidth = 240;

function NavBar(props) {
    const { window } = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const isMobile = useMediaQuery('(max-width:850px)');
    const location = useLocation();

    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const useStyles = makeStyles((theme) => ({
        appBar: {
            backgroundColor: '#2c5aa0 !important',
            minHeight: 135,
            paddingTop: 12,
            [theme.breakpoints.down('sm')]: {
                minHeight: 75,
            },
        },
    }));
    const classes = useStyles();

    const drawer = (
        <nav onClick={handleDrawerToggle} style={{ textAlign: 'center', backgroundColor: '#ffffff' }}>
            <img
                src={ChinookLogo}
                alt="Chinook Water Testing logo"
                width="200"
                style={{ marginTop: 20, marginBottom: 10 }}
                loading="lazy"
            />
            <Divider />
            <Box sx={{ backgroundColor: '#f5f5f5' }}>
                <List disablePadding>
                    <ListItem disablePadding disableGutters sx={{ padding: 0, margin: 0 }}>
                        <Link to="/" aria-label="Home" style={{ textDecoration: 'none', width: '100%' }}>
                            <ListItemButton
                                style={{
                                    textAlign: 'center',
                                    borderLeft: location.pathname === '/' ? '8px solid red' : '8px solid transparent',
                                    backgroundColor: location.pathname === '/' ? '#e0e0e0' : 'transparent',
                                    padding: '25px 20px',
                                    textTransform: 'none',
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                    <HomeIcon fontSize="medium" style={{ marginRight: '10px', color: '#114796', flexShrink: 0 }} />
                                    <p style={{ fontSize: '1.2em', fontWeight: 500, margin: 0, flexGrow: 1, textAlign: 'left' }}>Home</p>
                                </Box>
                            </ListItemButton>
                        </Link>
                    </ListItem>

                    <ListItem disablePadding disableGutters sx={{ padding: 0, margin: 0 }}>
                        <Link to="/service-areas" style={{ textDecoration: 'none', width: '100%' }}>
                            <ListItemButton
                                style={{
                                    textAlign: 'center',
                                    borderLeft: [
                                        '/athol',
                                        '/benewah-county',
                                        '/blanchard',
                                        '/bonner-county',
                                        '/boundary-county',
                                        '/careywood',
                                        '/coeur-d-alene',
                                        '/colbert',
                                        '/deer-park',
                                        '/hayden',
                                        '/kootenai-county',
                                        '/mead',
                                        '/newport',
                                        '/oldtown',
                                        '/pend-oreille-county',
                                        '/post-falls',
                                        '/priest-lake',
                                        '/priest-river',
                                        '/rathdrum',
                                        '/sagle',
                                        '/sandpoint',
                                        '/service-areas',
                                        '/spirit-lake',
                                        '/spokane',
                                        '/spokane-county',
                                        '/stevens-county'
                                    ].some(route => location.pathname.startsWith(route))
                                        ? '8px solid red'
                                        : '8px solid transparent',
                                    backgroundColor: [
                                        '/athol',
                                        '/benewah-county',
                                        '/blanchard',
                                        '/bonner-county',
                                        '/boundary-county',
                                        '/careywood',
                                        '/coeur-d-alene',
                                        '/colbert',
                                        '/deer-park',
                                        '/hayden',
                                        '/kootenai-county',
                                        '/mead',
                                        '/newport',
                                        '/oldtown',
                                        '/pend-oreille-county',
                                        '/post-falls',
                                        '/priest-lake',
                                        '/priest-river',
                                        '/rathdrum',
                                        '/sagle',
                                        '/sandpoint',
                                        '/service-areas',
                                        '/spirit-lake',
                                        '/spokane',
                                        '/spokane-county',
                                        '/stevens-county'
                                    ].some(route => location.pathname.startsWith(route))
                                        ? '#e0e0e0'
                                        : 'transparent',
                                    padding: '25px 20px',
                                    textTransform: 'none',
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                    <BuildCircleIcon fontSize="medium" style={{ marginRight: '10px', color: '#114796', flexShrink: 0 }} />
                                    <p style={{ fontSize: '1.2em', fontWeight: 500, margin: 0, flexGrow: 1, textAlign: 'left' }}>Service Areas</p>
                                </Box>
                            </ListItemButton>
                        </Link>
                    </ListItem>

                    <ListItem disablePadding disableGutters sx={{ padding: 0, margin: 0 }}>
                        <Link to="/pricing" style={{ textDecoration: 'none', width: '100%' }}>
                            <ListItemButton
                                style={{
                                    textAlign: 'center',
                                    borderLeft: location.pathname === '/pricing' ? '8px solid red' : '8px solid transparent',
                                    backgroundColor: location.pathname === '/pricing' ? '#e0e0e0' : 'transparent',
                                    padding: '25px 20px',
                                    textTransform: 'none',
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                    <PaidIcon fontSize="medium" style={{ marginRight: '10px', color: '#114796', flexShrink: 0 }} />
                                    <p style={{ fontSize: '1.2em', fontWeight: 500, margin: 0, flexGrow: 1, textAlign: 'left' }}>Pricing</p>
                                </Box>
                            </ListItemButton>
                        </Link>
                    </ListItem>

                    <ListItem disablePadding disableGutters sx={{ padding: 0, margin: 0 }}>
                        <Link to="/contact" style={{ textDecoration: 'none', width: '100%' }}>
                            <ListItemButton
                                style={{
                                    textAlign: 'center',
                                    borderLeft: location.pathname === '/contact' ? '8px solid red' : '8px solid transparent',
                                    backgroundColor: location.pathname === '/contact' ? '#e0e0e0' : 'transparent',
                                    padding: '25px 20px',
                                    textTransform: 'none',
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                    <ContactMailIcon fontSize="medium" style={{ marginRight: '10px', color: '#114796', flexShrink: 0 }} />
                                    <p style={{ fontSize: '1.2em', fontWeight: 500, margin: 0, flexGrow: 1, textAlign: 'left' }}>Contact</p>
                                </Box>
                            </ListItemButton>
                        </Link>
                    </ListItem>

                    <ListItem disablePadding disableGutters sx={{ padding: 0, margin: 0 }}>
                        <ListItemButton
                            onClick={(event) => {
                                event.stopPropagation();
                                handleDrawerToggle();
                            }}
                            style={{
                                textAlign: 'center',
                                borderLeft: '8px solid transparent',
                                backgroundColor: 'transparent',
                                padding: '25px 20px',
                                textTransform: 'none',
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                <CancelIcon fontSize="medium" style={{ marginRight: '10px', color: '#114796', flexShrink: 0 }} />
                                <p style={{ fontSize: '1.2em', fontWeight: 500, margin: 0, flexGrow: 1, textAlign: 'left' }}>Close</p>
                            </Box>
                        </ListItemButton>
                    </ListItem>
                </List>
            </Box>
        </nav>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <nav style={{ display: 'flex' }} role="navigation" aria-label="Primary">
            <CssBaseline />
            <AppBar component="nav" className={classes.appBar}>
                {isMobile ? (
                    <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                        {/* Hamburger */}
                        <Box sx={{ display: 'flex', alignItems: 'center', width: '12%' }}>
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                edge="start"
                                onClick={handleDrawerToggle}
                                sx={{ ml: 0.5 }}
                            >
                                <MenuIcon sx={{ fontSize: '2rem' }} />
                            </IconButton>
                        </Box>

                        {/* Phone number centered */}
                        <Box sx={{ width: '66%', textAlign: 'center' }}>
                            <Typography variant="body1" sx={{ fontFamily: 'sans-serif', fontSize: '1em' }}>
                                <a href="tel:+12083523909" style={{ textDecoration: 'none', color: 'inherit' }} aria-label="Call Chinook Water Testing">
                                    +1 (208) 352-3909
                                </a>
                            </Typography>
                        </Box>

                        {/* Logo right aligned */}
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '22%', pr: 0.5 }}>
                            <Link to="/" aria-label="Home">
                                <img
                                    src={ChinookLogo}
                                    width="82"
                                    alt="Chinook Water Testing logo"
                                    style={{ borderRadius: '50%' }}
                                    loading="lazy"
                                />
                            </Link>
                        </Box>
                    </Toolbar>
                ) : (
                    <Toolbar>
                        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                            <Link to="/" aria-label="Home">
                                <img
                                    src={ChinookLogo}
                                    width="150"
                                    alt="Chinook Water Testing logo"
                                    style={{ margin: '12px 20px 15px 0px', borderRadius: '50%' }}
                                    loading="lazy"
                                />
                            </Link>
                            <Typography variant="body1" style={{ fontFamily: 'sans-serif', fontSize: '1.2em' }}>
                                <a href="tel:+12083523909" style={{ textDecoration: 'none', color: 'inherit' }} aria-label="Call Chinook Water Testing">
                                    +1 (208) 352-3909
                                </a>
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex' }}>
                            <Link to="/"><Button sx={{ color: '#fff', mx: 1, fontSize: '1.1em', fontWeight: 400, letterSpacing: .5 }}>Home</Button></Link>

                            {/* Inlined ServiceAreasDropdown */}
                            <>
                                <Button
                                    id="service-areas-button"
                                    aria-haspopup="true"
                                    aria-controls={Boolean(anchorEl) ? 'service-areas-menu' : undefined}
                                    aria-expanded={Boolean(anchorEl) ? 'true' : undefined}
                                    sx={{ color: '#fff', mx: 1, fontSize: '1.1em', fontWeight: 400, letterSpacing: .5 }}
                                    onClick={handleClick}
                                >
                                    Our Service Areas
                                </Button>
                                <Menu
                                    id="service-areas-menu"
                                    anchorEl={anchorEl}
                                    open={Boolean(anchorEl)}
                                    onClose={handleClose}
                                    MenuListProps={{ 'aria-labelledby': 'service-areas-button' }}
                                    disableScrollLock
                                >
                                    <MenuItem onClick={handleClose} component={Link} to="/athol">Athol</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/blanchard">Blanchard</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/careywood">Careywood</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/coeur-d-alene">Coeur d'Alene</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/hayden">Hayden</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/oldtown">Oldtown</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/post-falls">Post Falls</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/priest-lake">Priest Lake</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/priest-river">Priest River</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/rathdrum">Rathdrum</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/sagle">Sagle</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/sandpoint">Sandpoint</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/spirit-lake">Spirit Lake</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/benewah-county">Benewah County</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/bonner-county">Bonner County</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/boundary-county">Boundary County</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/kootenai-county">Kootenai County</MenuItem>
                                    <Divider />
                                    <MenuItem onClick={handleClose} component={Link} to="/colbert">Colbert</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/deer-park">Deer Park</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/mead">Mead</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/newport">Newport</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/spokane">Spokane</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/pend-oreille-county">Pend Oreille County</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/spokane-county">Spokane County</MenuItem>
                                    <MenuItem onClick={handleClose} component={Link} to="/stevens-county">Stevens County</MenuItem>
                                    <Divider />
                                    <MenuItem onClick={handleClose} component={Link} to="/service-areas">Other Service Areas</MenuItem>
                                </Menu>
                            </>
                            <Link to="/pricing"><Button sx={{ color: '#fff', mx: 1, fontSize: '1.1em', fontWeight: 400, letterSpacing: .5 }}>Pricing</Button></Link>
                            <Link to="/contact"><Button sx={{ color: '#fff', mx: 1, fontSize: '1.1em', fontWeight: 400, letterSpacing: .5 }}>Contact</Button></Link>
                        </Box>
                    </Toolbar>
                )}
            </AppBar>

            {/* Static links for react-snap to crawl in dynamic mode */}
            <div style={{ display: 'none' }}>
                <a href="/">Home</a>
                <a href="/pricing">Pricing</a>
                <a href="/contact">Contact</a>
                <a href="/service-areas">Service Areas</a>
                <a href="/athol">Athol</a>
                <a href="/blanchard">Blanchard</a>
                <a href="/coeur-d-alene">Coeur d'Alene</a>
                <a href="/post-falls">Post Falls</a>
                <a href="/priest-river">Priest River</a>
                <a href="/rathdrum">Rathdrum</a>
                <a href="/sandpoint">Sandpoint</a>
                <a href="/spirit-lake">Spirit Lake</a>
                <a href="/deer-park">Deer Park</a>
                <a href="/newport">Newport</a>
                <a href="/spokane">Spokane</a>
                <a href="/benewah-county">Benewah County</a>
                <a href="/bonner-county">Bonner County</a>
                <a href="/kootenai-county">Kootenai County</a>
                <a href="/pend-oreille-county">Pend Oreille County</a>
                <a href="/spokane-county">Spokane County</a>
                <a href="/careywood">Careywood</a>
                <a href="/hayden">Hayden</a>
                <a href="/oldtown">Oldtown</a>
                <a href="/priest-lake">Priest Lake</a>
                <a href="/sagle">Sagle</a>
                <a href="/colbert">Colbert</a>
                <a href="/mead">Mead</a>
                <a href="/boundary-county">Boundary County</a>
                <a href="/stevens-county">Stevens County</a>
            </div>

            <Box component="nav">
                {isMobile && (
                    <Drawer
                        container={container}
                        variant="temporary"
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        ModalProps={{ keepMounted: true }}
                        sx={{
                            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                        }}
                    >
                        {drawer}
                    </Drawer>
                )}
            </Box>
        </nav>
    );
}

export default NavBar;
